import React from 'react'
import type { Icon } from 'shared/utils'

const CirclePencil = (props: Icon) => {
    const {
        color = 'black',
        size = 24,
        className = 'pencil',
        stroke = 'black',
        ...otherProps
    } = props
    return (
        <svg
            width={size}
            height={size}
            className={className}
            viewBox="0 0 24 24"
            {...otherProps}>
            <g fill="none" fillRule="evenodd">
                <path
                    d="M6 18l2.952-.571 7.021-7.022-2.38-2.38-7.022 7.02L6 18zM17.814 7.671L16.33 6.186a.632.632 0 00-.895 0l-1.162 1.161 2.38 2.381 1.162-1.162a.632.632 0 000-.895z"
                    fill={color}
                />
                <circle
                    strokeOpacity={0.85}
                    stroke={stroke}
                    strokeWidth={1.5}
                    cx={12}
                    cy={12}
                    r={11.25}
                />
            </g>
        </svg>
    )
}

export { CirclePencil }
